import { DELETE, GET, POST, PUT } from './ApiService';
import appConfig from '../config/app-config';
import { getAllStickers, getStickerDetail } from './mocks/StickerServiceMock';

const baseUrl = `${appConfig.baseUri}/management/v1/Stickers`;
export default class StickerService {

  static async getAll() {
    if (appConfig.isTest) {
      return { data: getAllStickers(), error: false };
    }

    return GET({
      url: baseUrl,
      token: true,
    });
  }

  static async getById(id) {
    if (appConfig.isTest) {
      return { data: getStickerDetail(), error: false };
    }

    return GET({
      url: `${baseUrl}/${id}`,
      token: true,
    });
  }

  static async save(request) {
    return POST({
      url: baseUrl,
      token: true,
      body: request,
    });
  }

  static async update(id, request) {
    return PUT({
      url: `${baseUrl}/${id}`,
      token: true,
      body: request,
    });
  }

  static async updateOrder(id, order) {
    return POST({
      url: `${baseUrl}/OrderUpdate`,
      token: true,
      body: { StickerId: id, Order: order },
    });
  }

  static async deleteById(id) {
    return DELETE({
      url: `${baseUrl}/${id}`,
      token: true,
    });
  }

  static async deleteAllById(ids) {
    return POST({
      url: `${baseUrl}/BatchDelete`,
      token: true,
      body: ids,
    });
  }
}
